import Head from "next/head";
import { useRouter } from "next/router";
import Cart from "../components/cart/cart";
import PageFooter from "../components/footer/page-footer";
import { NavBarMobile } from "../components/navbar-mobile/navbar-mobile";
import PageNavbar from "../components/navbar/navbar";
import Searchbar from "../components/searchbar/searchbar";
import CartHandler from "../utils/shopping-cart-handler";
import logo from "./../public/sporsam-logo-white.png";
import styles from "./app.module.css";
import { LazyLoadImage } from "react-lazy-load-image-component";
export default function MyApp({
  Component,
  pageProps,
}: {
  Component: any;
  pageProps: any;
}) {
  const router = useRouter();
  const handleClick = (event: any) => {
    event.stopPropagation();
    router.push("/");
  };
  if (typeof document !== "undefined") {
    CartHandler.init(document);
  }

  return (
    <>
      <Head>
        <title>Sportsam - Sportsutstyr samlet smartere</title>
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta
          name="keywords"
          content="sportsutstyr, treningsutstyr, treningsklær, fritidsklær, løpesko, sykler, proteinpulver, kosttilskudd, billig sportsutstyr, sammenligne priser sports"
        ></meta>
        <meta
          key="description"
          name="description"
          content="Sportsam har samlet et stort utvalg sportsutstyr fra en rekke produsenter og leverendører slik at du skal kunne få den beste prisen."
        />
        <meta
          key="og:title"
          property="og:title"
          content="Sportsam - Sportsutstyr samlet smartere"
        />
        <meta
          key="og:description"
          property="og:description"
          content="Sportsam har samlet et stort utvalg sportsutstyr fra en rekke produsenter og leverendører slik at du skal kunne få den beste prisen."
        />
        <meta key="og:type" property="og:type" content="website" />
        <meta property="og:site_name" content="Sportsam" />
        <link
          rel="preload"
          as="style"
          href="https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap"
        />
        <link
          rel="stylesheet"
          href="https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap"
        />        

        <link
          rel="icon"
          type="image/png"
          href="/favicon-96x96.png"
          sizes="96x96"
        />
        <link rel="icon" type="image/svg+xml" href="/favicon.svg" />
        <link rel="shortcut icon" href="/favicon.ico" />
        <link
          rel="apple-touch-icon"
          sizes="180x180"
          href="/apple-touch-icon.png"
        />
        <meta name="apple-mobile-web-app-title" content="Sportsam" />
        <link rel="manifest" href="/site.webmanifest" />
        <link rel="index" href="https://sportsam.no" />
      </Head>
      <div className={styles.headerWrapper}>
        <div className={styles.commercialBar}>
          <span>Sammenlign priser</span>
          <span>Over 10 000 produkter</span>
          <span>Fra kjente nettbutikker</span>
        </div>
        <header className={styles.header}>
          <div className={styles.headerText} onClick={handleClick}>
            <div id={styles.mainHeaderText}>
              Sportsam.no
              <LazyLoadImage src={logo.src} id={styles.headerTextLogo} alt="SportsamLogo" />
            </div>
            <div id={styles.secondaryHeaderText}>
              &nbsp;- Sportsutstyr samlet smartere!
            </div>
          </div>
          <div
            className="showInMobile showOnPad"
            style={{ overflow: "visible" }}
          >
            <Cart />
          </div>
            <PageNavbar />
            <span className="hideInMobile hideOnPad">
            <Cart />
          </span>
        </header>
      </div>
      <section className={styles.searchBarWrapper}>
        <Searchbar />
      </section>
      <div
        className={
          router.pathname.toLowerCase().indexOf("sok") == -1
            ? styles.mainWrapper
            : ""
        }
      >
        <Component {...pageProps} />
      </div>
      <NavBarMobile />
      <PageFooter />
      <style jsx global>
        
        
        {`
        :root {
          --primary-color: #6b6ae3;
          --primary-color-s2: #5453cf;
          --accent-color: #ee7559;
          --secondary-color: #1f9c6b;
          --analogous-color: #41407e;
          --background-color: #fafafd;
          --surface-color: #ffffff;
          --surface-muted: #f3f3f8;
          --text-color: #14132b;
          --muted-color: #6c6c83;
          --line-color: #e5e5ee;
          --highlight-color: #e8f6f0;
          --radius-sm: 10px;
          --radius-md: 16px;
          --radius-lg: 24px;
          --shadow-sm: 0 1px 2px rgba(20, 19, 43, .04), 0 4px 14px rgba(20, 19, 43, .04);
          --shadow-md: 0 12px 32px rgba(20, 19, 43, .08);
        }
        html,
        body {
          padding: 0;
          margin: 0;
          font-size: 16px;
          background: var(--background-color);
          font-family: "Plus Jakarta Sans", sans-serif;
          color: var(--text-color);
          line-height: 1.5;
          -webkit-font-smoothing: antialiased;
          -moz-osx-font-smoothing: grayscale;
          scroll-behavior: smooth;
        }
        html {
          background: var(--background-color);
        }
        h1 {
          font-size: clamp(2rem, 4vw, 3rem);
          line-height: 1.1;
          letter-spacing: -.04em;
        }
        h2 {
          font-size: clamp(1.5rem, 3vw, 2rem);
          line-height: 1.15;
          letter-spacing: -.03em;
        }
        a {
          color: inherit;
          text-decoration: none;
        }
        a:visited {
          color: inherit;
        }
        .pinkHeader {
          background: #db3ca9;
          color: var(--text-color);
          padding: 8px;
        }
        #__next {
          height: inherit;
        }
        * {
          box-sizing: border-box;
        }
        button, input, select { font: inherit; }
        button { cursor: pointer; }
        img { max-width: 100%; }
        ::selection { background: rgba(107, 106, 227, .22); }
        @media (prefers-reduced-motion: reduce) {
          *, *::before, *::after { scroll-behavior: auto !important; transition-duration: .01ms !important; }
        }
        .showOnPad {
          display: none;
        }
        .hideInMobile {
          display: block;
        }
        .showInMobile {
          display: none;
        }
        @media only screen and (max-width: 600px) {
          .hideInMobile {
            display: none;
          }
          .showInMobile {
            display: block;
            overflow: hidden;
            text-align: center;
          }
        }
        @media only screen and (min-width: 600px) and (max-width: 1200px) {
          .hideOnPad {
            display: none;
          }
          .showOnPad {
            display: block;
          }
        }
      `}</style>
    </>
  );
}
